import { configureStore } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';
import entitiesReducer from './entitiesSlice';
import ordersReducer from './ordersSlice';
import marketMakerOrdersReducer from './marketMakerOrdersSlice';
import positionsReducer from './positionsSlice';
import accountReducer from './accountSlice';
import transactionsReducer from './transactionsSlice';
import userReducer from './userSlice';
import marginHoldSlice from './marginHoldSlice';
import commoditiesSlice from './commoditiesSlice';

const logger = createLogger({
  // Customize logger options here
  // collapsed: (getState, action, logEntry) => !logEntry.error,
  // diff: true
});

const middleware = (getDefaultMiddleware) => {
  const defaultMiddleware = getDefaultMiddleware();
  
  // Only add logger in development
  if (process.env.NODE_ENV === 'development') {
    return [...defaultMiddleware, logger];
  }
  
  return defaultMiddleware;
};

export const store = configureStore({
  reducer: {
    entities: entitiesReducer,
    orders: ordersReducer,
    marketMakerOrders: marketMakerOrdersReducer,
    positions: positionsReducer,
    account: accountReducer,
    transactions: transactionsReducer,
    user: userReducer,
    marginHolds: marginHoldSlice,
    commodities: commoditiesSlice,
  },
  middleware,
  devTools: process.env.NODE_ENV !== 'production',
});